// ProvidingExpertSpecialtyCareSection.js
import React from 'react';
import { Phone } from 'lucide-react';
import providingExpertSpecialtyCareImage from '../assets/providing-expert-specialty-care-image.jpg';

const ProvidingExpertSpecialtyCareSection = () => {
  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">

          {/* Left Image */}
          <div className="relative order-2 lg:order-1">
            <img
              src={providingExpertSpecialtyCareImage}
              alt="A carer assisting an older man with a walker"
              className="w-full h-[420px] lg:h-[560px] object-cover rounded-2xl"
            />
          </div>

          {/* Right Content */}
          <div className="order-1 lg:order-2">
            <p className="text-bnAccent text-xs md:text-sm font-medium tracking-[0.22em] uppercase mb-5">
              Specialty Care
            </p>
            <h2 className="font-display font-light text-bnInk leading-[1.1] text-3xl md:text-4xl lg:text-5xl mb-6">
              Providing Expert Specialty Care for Complex Health Needs
            </h2>

            <div className="space-y-4 text-bnBody text-base leading-relaxed mb-10 max-w-lg">
              <p>
                At B &amp; N Enterprise, we understand that specialty care needs more than routine support, it calls for expertise, empathy, and consistency. Whether someone is recovering after a hospital stay, managing a chronic condition, or living with a disability, our carers deliver tailored in-home care that supports safety, comfort, and independence. Every care plan is built around individual needs, ensuring personalised attention and peace of mind for families.
              </p>
              <p>
                From medication reminders and meal preparation to mobility assistance and household upkeep, we focus on helping clients maintain their routines with dignity and confidence. Our specialty care programmes are flexible and personalised, giving families the reassurance that their loved ones are receiving attentive care in the place they feel most comfortable, their own home.
              </p>
            </div>

            <a
              href="tel:+61480804640"
              className="inline-flex items-center gap-2 bg-bnAccent hover:bg-bnAccentDark text-white font-medium text-sm px-7 py-3.5 rounded-full transition-colors"
            >
              <Phone size={18} />
              Call: +61 480 804 640
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProvidingExpertSpecialtyCareSection;
